import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_ASSIGN_SKU_DETAILS  } from '../../helpers/constants/apiUrl';

export default function getAssignSku(req = '') {
    
    return new Promise((res, rej) => {
        triggerSimpleAjax(
            GET_ASSIGN_SKU_DETAILS + req ,
            'GET',
            {},
            (response) => {
                res(response);
            },
            error => {
                rej(error);
            }
        );
    });
}